<script lang="ts">
	import { Section } from "#lib/web-ui/primitives/index.js";
	import { cloudinaryUrl } from "#lib/shared/cloudinary.js";

	let { entityName }: { entityName: string } = $props();

	const currentYear = new Date().getFullYear();
</script>

<Section
	class="border-background/10 border-t bg-transparent py-4 md:py-4 [&>div]:flex [&>div]:items-center [&>div]:justify-between"
>
	<p class="text-background/60 text-sm">
		&copy; {currentYear}
		{entityName}. All rights reserved.
	</p>
	<a href="https://www.eosworldwide.com/" target="_blank" rel="noopener noreferrer">
		<img
			src={cloudinaryUrl("fergmarcapital-com/eos-badge", { width: 100 })}
			alt="EOS Badge"
			class="h-8 w-auto"
			width="100"
			height="66"
			loading="lazy"
		/>
	</a>
</Section>
